import register from "../../../../assets/img/landings/invet/flow-icons/register.png";
import qr from "../../../../assets/img/landings/invet/flow-icons/qr.png";
import note from "../../../../assets/img/landings/invet/flow-icons/note.png";
import track from "../../../../assets/img/landings/invet/flow-icons/track.png";
import login from "../../../../assets/img/landings/invet/flow-icons/login.png";
import setup from "../../../../assets/img/landings/invet/flow-icons/setup.png";
import comments from "../../../../assets/img/landings/invet/flow-icons/comments.png";

export const data = {
  title: "User flow",
  list: [
    { icon: register, text: "Register users in the admin panel" },
    { icon: register, text: "Manage vehicles and users in the admin panel" },
    { icon: login, text: "Log in to the app" },
    { icon: note, text: "See all existing orders and their statuses" },
    { icon: setup, text: "Set up and receive notifications" },
    { icon: comments, text: "Leave comments and see order history" },
    { icon: track, text: "Track orders on the map" },
    { icon: qr, text: "Scan QR code of the order and change its status" },
  ],
};
